export class MapList
{
  static add<K,V>( map:Map<K,V[]>, k:K, v:V )
  {
    if ( ! map.has( k ) )
    {
      map.set( k, [] );
    }

    map.get( k ).push( v );
  }

  
}